import Vue from 'vue';
import { SidePanelMode } from '@/components/ui/side-panel/SidePanelMode';

interface State {
  rightOpen: boolean;
  leftOpen: boolean;
  mode: SidePanelMode;
}

const state: State = Vue.observable({
  rightOpen: false,
  leftOpen: false,
  mode: SidePanelMode.READABILITY
});

class SidePanelStore {
  get mode(): SidePanelMode {
    return state.mode;
  }

  get rightPanelIsOpen() {
    return state.rightOpen;
  }

  get leftPanelIsOpen(): boolean {
    return state.leftOpen;
  }

  set leftPanelIsOpen(open: boolean) {
    state.leftOpen = open;
  }

  set rightPanelIsOpen(open: boolean) {
    state.rightOpen = open;
  }

  set mode(mode: SidePanelMode) {
    state.mode = mode;
  }
}

export default new SidePanelStore();
